import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "justify-center items-center py-6 flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = { class: "w-120 relative max-h-full flex flex-col justify-between bg-white rounded-2xl" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "p-4 rounded-t-2xl border-b border-gray-lp-1400 mb-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "inline-flex justify-between w-full" }, [
    /*#__PURE__*/_createVNode("div", { class: "w-full" }, [
      /*#__PURE__*/_createVNode("h1", { class: "text-gray-lp-300 text-xl font-semibold" }, " Daftar Kurir ")
    ])
  ])
], -1)
const _hoisted_5 = {
  class: "content overflow-auto p-4",
  style: {"max-height":"40rem"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-gray-lp-300 text-sm font-semibold" }, [
    /*#__PURE__*/_createVNode("th", { class: "text-left py-3 px-3 w-1/20" }, "Shift"),
    /*#__PURE__*/_createVNode("th", { class: "text-left py-3 px-3 w-1/4" }, "Mulai"),
    /*#__PURE__*/_createVNode("th", { class: "text-left py-3 px-3 w-1/4" }, "Selesai"),
    /*#__PURE__*/_createVNode("th", { class: "text-left py-3 px-3 w-1/2" }, "Nama Kurir")
  ])
], -1)
const _hoisted_7 = { class: "text-gray-lp-300 text-sm" }
const _hoisted_8 = { class: "py-3 px-3 w-1/20 text-left" }
const _hoisted_9 = { class: "py-3 px-3 w-1/4 text-left" }
const _hoisted_10 = { class: "py-3 px-3 w-1/4 text-left" }
const _hoisted_11 = { class: "py-3 px-3 w-1/2 text-left" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 cursor-pointer",
  alt: "x"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "opacity-75 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("table", null, [
            _hoisted_6,
            _createVNode("tbody", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_8, _toDisplayString(index + 1), 1),
                  _createVNode("td", _hoisted_9, _toDisplayString(item.startTime), 1),
                  _createVNode("td", _hoisted_10, _toDisplayString(item.endTime), 1),
                  _createVNode("td", _hoisted_11, " [" + _toDisplayString(item.courierId) + "] " + _toDisplayString(item.courierName), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode("button", {
          class: "absolute top-4 right-4",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
        }, [
          _hoisted_12
        ])
      ])
    ]),
    _hoisted_13
  ]))
}